module.exports = __webpack_public_path__ + "img/FatCatGameStudioBackground.e75e8efe.png";